import * as React from 'react';

import { ContentTypeFilterValue } from '../../models/ContentTypeFilterValue';
import { FilterTypes } from '../../models/FilterTypes';
import { MixedContentTypeSearchResult, SearchResultItem, SearchResultList } from '../../models/SearchResultTypes';
import { FeatureFlag, FeatureFlagService } from '../../services/FeatureFlagService';
import { NavigationService } from '../../services/NavigationService';
import { FilterAction, TelemetryService } from '../../services/TelemetryService';
import { FilterAllOption, FilterQuery } from '../../state/FilterState';

// eslint-disable-next-line prettier/prettier
export interface QuickFilterOwnProps { }

export interface QuickFilterStateProps {
  readonly filterSelected: { id: string; value: string };
  readonly allFilterValues: FilterQuery;
  readonly contentType: ContentTypeFilterValue;
  readonly mixedContentResults?: MixedContentTypeSearchResult;
  readonly singleContentResults?: SearchResultList<SearchResultItem>;
  readonly isLoadingFilterContent: boolean;
  readonly searchTerm?: string;
}

export interface QuickFilterDispatchProps {
  readonly updateFilter: (id: string, value: string, filterType: FilterTypes) => void;
}

export type QuickFilterProps = QuickFilterOwnProps & QuickFilterStateProps & QuickFilterDispatchProps;

export abstract class QuickFilter<Props extends QuickFilterProps, State = {}> extends React.PureComponent<Props, State> {
  protected onDropDownValueChanged(id: string, filterType: FilterTypes, filterName?: string) {
    const name = filterName ? filterName : id;
    this.props.updateFilter(id, name, filterType);
    NavigationService.instance.navigateByFilter(filterType, id);
  }

  protected sendFiltersUpdatedTelemetryEvent(
    value: string,
    prevValue: string,
    filterType: FilterTypes,
    contentType: ContentTypeFilterValue
  ) {
    if (!FeatureFlagService.instance.getValue(FeatureFlag.searchProductMetrics)) {
      if (value === FilterAllOption && prevValue !== value) {
        TelemetryService.instance.filtersUpdatedEvent(filterType.toString(), FilterAction.Removed, contentType);
      } else if (prevValue === FilterAllOption && prevValue !== value) {
        TelemetryService.instance.filtersUpdatedEvent(filterType.toString(), FilterAction.Added, contentType);
      } else if (prevValue !== value) {
        TelemetryService.instance.filtersUpdatedEvent(filterType.toString(), FilterAction.Updated, contentType);
      }
    } else {
      if (value === FilterAllOption && prevValue !== value) {
        TelemetryService.instance.filtersUpdatedEvent(filterType.toString(), FilterAction.Removed, contentType, this.props.searchTerm);
      } else if (prevValue === FilterAllOption && prevValue !== value) {
        TelemetryService.instance.filtersUpdatedEvent(filterType.toString(), FilterAction.Added, contentType, this.props.searchTerm);
      } else if (prevValue !== value) {
        TelemetryService.instance.filtersUpdatedEvent(filterType.toString(), FilterAction.Updated, contentType, this.props.searchTerm);
      }
    }
  }
}
